<template>
    <div class="filters">
        <sp-button @click.native="isFilterActive = !isFilterActive" text="Filters" icon="bar" class="filters__header"></sp-button>
        <v-expand-transition>
            <div class="filters__content" v-show="isFilterActive">
                <div class="filters__wrapper">
                    <slot />
                </div>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
export default {
    name: 'DataTableFilters',
    components: {
        SpButton
    },
    data () {
        return {
            isFilterActive: false
        }
    }
}
</script>

<style scoped lang="scss">
.filters {
    margin-bottom: 5px;
    padding-bottom: 10px;

    &__content {
        .label {
            color: $inactive;
        }
    }

    &__wrapper {
        padding-top: 15px;
    }
}
</style>
